var _rect, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWormLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 48,
    viewBox: "0 0 140 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#A855F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12 L14 36 L24 16 L34 36 L42 12",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 33,
    fill: "white",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 26,
    letterSpacing: "-0.5px"
  }, "Worm")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWormLogoFull);
export default __webpack_public_path__ + "static/media/worm_logo_full.eac4cf7d8e9361730e8f6550ff7eb87a.svg";
export { ForwardRef as ReactComponent };